import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtilsV2 } from '@shared/utils';
import { ProfileApi, RequestStrategyEnum, type WithSignal, type ProfileFeaturesResponse } from '@shared/api';

const getProfileFeaturesEffect = createEffect(({ signal }: WithSignal = {}) => ProfileApi.getProfileFeatures(signal));
const clearEvent = createEvent();

const $dataStore = createStore<ProfileFeaturesResponse | null>(null)
  .on(getProfileFeaturesEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getProfileFeaturesEffect.pending, (_, data) => data)
  .on(getProfileFeaturesEffect.fail, () => false)
  .on(getProfileFeaturesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getProfileFeaturesEffect, () => null)
  // .on(getProfileFeaturesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getProfileFeaturesEffect.fail, () => 'Something went wrong while fetching Profile Features. Please try again.')
  .on(getProfileFeaturesEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $profileFeatureStore = {
  events: {
    getProfileFeatures: ApiUtilsV2.wrapperApi(getProfileFeaturesEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
